import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { collection, query, where, getDocs, limit } from "firebase/firestore";
import { db } from "../firebase.js";
import Lodinging from "../components_root/loading.jsx";
import Loadingimg from "../components_root/loadingimg.jsx";
import Loading_items from "../components_root/loading_items.jsx";
import Cookies from "js-cookie";
import { Toast } from '../components_root/ToastContext.jsx';
import { Helmet } from "react-helmet";
import { CiRead } from "react-icons/ci";
import { IoIosGitCompare } from "react-icons/io";
import { GiCash } from "react-icons/gi";
import { TbAward } from "react-icons/tb";
import { SiGnuprivacyguard } from "react-icons/si";
import { TbMessageQuestion } from "react-icons/tb"; 
import { MdShoppingCart, MdKeyboardArrowRight, MdOutlineVerifiedUser, MdStarOutline, MdArrowRight, MdOpenInFull, MdInfoOutline, MdRepeat, MdReport } from "react-icons/md";
import logo_default from "../assets/logo_default.jpg";
import banner_default from "../assets/banner_default.jpg";
import { BsLightningCharge } from "react-icons/bs";
import { TbTruckReturn } from "react-icons/tb";
import "./product_view.css";
import MediaViewer from "./mediaviewer.js";
import Rating from "./rating.js";
import Comments from "./comments.jsx";
import UpdateView from "./updateview.js";
import Saved from "./saved.js";
import TechnicalDetails from "./technicaldetails.jsx";
import AdditionalInformation from "./additionalInformation.jsx";
import ReviewSlideshow from "./reviewslideshow";
import PPTSlideshow from "./PPTSlideshow.jsx";
import Add_cart from "../cart_root/add_cart.js";
import Add_cart_buy from "../cart_root/add_cart_buy.js";
import VideoSlideshow from "./VideoSlideshow.jsx";

export const seoFallback = {
  title: "aooz | Amazing Products & Tools",
  description: "Check out products and services on aooz.",
  keywords: "aooz products, services, tools",
  url: "https://aooz.in",
  image: "https://aooz.in/assets/logo.png",
};

export default function Product_view({ data }) {
  const location = useLocation();
  const { Toastshow } = Toast();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("home");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);
  const [isLoading3, setIsLoading3] = useState(true);
  const [uid, setUid] = useState(data.uid);
  const [product_filedata, setProduct_filedata] = useState([]);
  const [media_view_fileurl, setMedia_view_fileurl] = useState("");
  const [productsdata, setProductsdata] = useState([]);
  const [islogin, setIslogin] = useState(false);
  const [guid, setguid] = useState('');
  useEffect(() => {
    const existingsessiontoken = Cookies.get("sessiontoken");
    if (existingsessiontoken !== null && existingsessiontoken !== undefined) {
      setIslogin(true);
      setguid(Cookies.get("guid"));
    }
  }, [navigate]);

  const meta = {
    title: data?.title || seoFallback.title,
    description: data?.description || seoFallback.description,
    keywords: data?.keywords || seoFallback.keywords,
    image: data?.thumbnail || seoFallback.image,
    url: `https://aooz.in/${data?.uid || ""}`,
  };
  useEffect(() => {
    const fetchproducts = async () => {

      try {
        UpdateView(data.uid);
        setIsLoading2(true);
        const Query = query(
          collection(db, "products"),
          where("uid", "==", uid)
        );
        const snapshot = await getDocs(Query);
        const products = await Promise.all(
          snapshot.docs.map(async (docSnap) => {
            const docData = docSnap.data();
            const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
            let child = {};
            fieldsSnap.forEach((fieldDoc) => {
              const { fieldName, fieldValue } = fieldDoc.data();
              child[fieldName] = fieldValue;
            });
            return { uid: docSnap.id, ...docData, child };
          })
        );

        setProductsdata(products);

      } catch (err) {
        console.error("Error fetching products:", err);
      }
      setIsLoading2(false);
    };
    fetchproducts();

  }, [uid]);

  //
  //technicaldata 
  const [technicaldata, setTechnicaldata] = useState([]);

  useEffect(() => {
    const fetchTechnicalFields = async () => {
      try {
        setIsLoading3(true);

        // 1️⃣ Get the product document
        const productSnap = await getDocs(
          query(collection(db, "products"), where("uid", "==", uid))
        );

        if (productSnap.empty) {
          setTechnicaldata([]);
          setIsLoading3(false);
          return;
        }

        const products = await Promise.all(
          productSnap.docs.map(async (docSnap) => {
            const docData = docSnap.data();

            // 2️⃣ Get fields where category == "technical"
            const fieldsSnap = await getDocs(
              query(
                collection(docSnap.ref, "fields"),
                where("category", "==", "technical")
              )
            );

            // 3️⃣ Map fields to array
            const child = fieldsSnap.docs.map((fieldDoc) => fieldDoc.data());

            return { uid: docSnap.id, ...docData, child };
          })
        );

        setTechnicaldata(products);
      } catch (err) {
        console.error("Error fetching technical fields:", err);
      } finally {
        setIsLoading3(false);
      }
    };

    fetchTechnicalFields();
  }, [uid]);
  //Additional Information
  const [additionaldata, setAdditionaldata] = useState([]);

  useEffect(() => {
    const fetchAdditionalFields = async () => {
      try {
        setIsLoading3(true);

        // 1️⃣ Get the product document
        const productSnap = await getDocs(
          query(collection(db, "products"), where("uid", "==", uid))
        );

        if (productSnap.empty) {
          setTechnicaldata([]);
          setIsLoading3(false);
          return;
        }

        const products = await Promise.all(
          productSnap.docs.map(async (docSnap) => {
            const docData = docSnap.data();

            // 2️⃣ Get fields where category == "technical"
            const fieldsSnap = await getDocs(
              query(
                collection(docSnap.ref, "fields"),
                where("category", "==", "additional")
              )
            );

            // 3️⃣ Map fields to array
            const child = fieldsSnap.docs.map((fieldDoc) => fieldDoc.data());

            return { uid: docSnap.id, ...docData, child };
          })
        );

        setAdditionaldata(products);
      } catch (err) {
        console.error("Error fetching technical fields:", err);
      } finally {
        setIsLoading3(false);
      }
    };

    fetchAdditionalFields();
  }, [uid]);
  //
  //Additional Information
  const [salesdata, setSalesdata] = useState([]);

  useEffect(() => {
    const fetchsalesFields = async () => {
      try {
        setIsLoading3(true);

        // 1️⃣ Get the product document
        const productSnap = await getDocs(
          query(collection(db, "products"), where("uid", "==", uid))
        );

        if (productSnap.empty) {
          setSalesdata([]);
          setIsLoading3(false);
          return;
        }

        const products = await Promise.all(
          productSnap.docs.map(async (docSnap) => {
            const docData = docSnap.data();

            // 2️⃣ Get fields where category == "technical"
            const fieldsSnap = await getDocs(
              query(
                collection(docSnap.ref, "fields"),
                where("category", "==", "sales")
              )
            );

            // 3️⃣ Map fields to array
            const child = fieldsSnap.docs.map((fieldDoc) => fieldDoc.data());

            return { uid: docSnap.id, ...docData, child };
          })
        );

        setSalesdata(products);
      } catch (err) {
        console.error("Error fetching technical fields:", err);
      } finally {
        setIsLoading3(false);
      }
    };

    fetchsalesFields();
  }, [uid]);

  const handleRatingChange = (newRating) => {
    console.log("User selected rating:", newRating);
    // here you can save rating to backend (Firebase, API, etc.)
  };
  //companydata
  const [companydata, setCompanydata] = useState([]);
  useEffect(() => {
    const fetch_companies = async () => {
      try {
        if (!productsdata || productsdata.length === 0) return;

        setIsLoading(true);

        const companySnap = await getDocs(
          query(
            collection(db, "companies"),
            where("uid", "==", productsdata[0].companyuid)
          )
        );

        if (!companySnap.empty) {
          const companies = companySnap.docs.map(doc => ({
            ...doc.data(),
            uid: doc.id,
          }));
          setCompanydata(companies);
        } else {
          setCompanydata([]); // no match
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetch_companies();
  }, [productsdata]);

  useEffect(() => {
    const fetch_product_file = async () => {
      setIsLoading(true);

      try {
        // const companyuid = Cookies.get("select_company_uid");
        // const guid = Cookies.get("guid"); 
        const q = query(
          collection(db, "files"),
          where("filename", "==", "product"),
          where("fileuid", "==", uid)
        );

        const snapshot = await getDocs(q);
        const datafiles = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMedia_view_fileurl(datafiles[0].url);
        setProduct_filedata(datafiles);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching file data:", err);
        setIsLoading(false);
      }
    };

    fetch_product_file();
  }, [uid]);
  //
  const [manufacturer_filedata, setManufacturer_filedata] = useState(null);
  useEffect(() => {
    const fetch_product_file = async () => {
      setIsLoading(true);

      try {
        const q = query(
          collection(db, "files"),
          where("filename", "==", "manufacturer"),
          where("fileuid", "==", uid)
        );

        const snapshot = await getDocs(q);
        const datafiles = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setManufacturer_filedata(datafiles);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching file data:", err);
        setIsLoading(false);
      }
    };

    fetch_product_file();
  }, [uid]);
  //
  const [review_slideshow_filedata, setReview_slideshow_filedata] = useState([]);
  useEffect(() => {
    const fetch_product_file = async () => {
      setIsLoading(true);

      try {
        const q = query(
          collection(db, "files"),
          where("filename", "==", "reviewslideshow"),
          where("fileuid", "==", uid)
        );

        const snapshot = await getDocs(q);
        const datafiles = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setReview_slideshow_filedata(datafiles);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching file data:", err);
        setIsLoading(false);
      }
    };

    fetch_product_file();
  }, [uid]);


  const [pptphotoshowf_file_filedata, setPptphotoshowf_file_filedata] = useState([]);
  useEffect(() => {
    const fetch_product_file = async () => {
      setIsLoading(true);

      try {
        const q = query(
          collection(db, "files"),
          where("filename", "==", "pptphotoshow"),
          where("fileuid", "==", uid)
        );

        const snapshot = await getDocs(q);
        const datafiles = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPptphotoshowf_file_filedata(datafiles);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching file data:", err);
        setIsLoading(false);
      }
    };

    fetch_product_file();
  }, [uid]);

  const [explanation_filedata, setExplanation_filedata] = useState([]);
  useEffect(() => {
    const fetch_product_file = async () => {
      setIsLoading(true);

      try {
        const q = query(
          collection(db, "files"),
          where("filename", "==", "explanation"),
          where("fileuid", "==", uid)
        );

        const snapshot = await getDocs(q);
        const datafiles = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setExplanation_filedata(datafiles);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching file data:", err);
        setIsLoading(false);
      }
    };

    fetch_product_file();
  }, [uid]);
  //compareData
  const [compareData, setCompareData] = useState([]);
  useEffect(() => {
    const fetchProducts = async () => {
      const cat = data?.category;
      const scat = data?.subcategory;

      if (!cat || !scat) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);

        // Firestore query without "!="
        const Query = query(
          collection(db, "products"),
          where("category", "==", cat),
          where("subcategory", "==", scat),

          where("status", "==", true),
          limit(10)
        );

        const snapshot = await getDocs(Query);
        const products = await Promise.all(
          snapshot.docs.map(async (docSnap) => {
            const docData = docSnap.data();
            const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
            let child = {};
            fieldsSnap.forEach((fieldDoc) => {
              const { fieldName, fieldValue } = fieldDoc.data();
              child[fieldName] = fieldValue;
            });
            return { uid: docSnap.id, ...docData, child };
          })
        );

        // Filter out the first product manually
        const filteredProducts = products.filter(p => p.uid !== data?.uid);

        setCompareData(filteredProducts);

      } catch (err) {
        console.error("Error fetching products:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [data]);
  return (
    <div>


      {/* Dynamic Helmet */}
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:url" content={meta.url} />
      </Helmet>

      <div className="container_roots">
        <div className="p-1 items-back-fill">
          <table>
            <tbody>
              <tr>
                <td>
                  <div className="items-center">
                    {data?.category && (
                      <a className="text-off text-h3 cursor fcap hover-under">
                        {data.category}
                      </a>
                    )}
                    {data?.subcategory && (
                      <>
                        <MdKeyboardArrowRight className="icon-0 center text-off m-0" />
                        <a className="text-off text-h3 cursor fcap hover-under">
                          {data.subcategory}
                        </a>
                      </>
                    )}
                    {data?.item && (
                      <>
                        <MdKeyboardArrowRight className="icon-0 center text-off m-0" />
                        <a className="text-off text-h3 cursor fcap hover-under">
                          {data.item}
                        </a>
                      </>
                    )}
                    {data?.usecase && (
                      <>
                        <MdKeyboardArrowRight className="icon-0 center text-off m-0" />
                        <a className="text-off text-h3 cursor fcap hover-under">
                          {data.usecase}
                        </a>
                      </>
                    )}
                  </div>
                </td>

              
              </tr>
            </tbody>
          </table>
        </div>

        <div className="container_size m-top p-22">
          <div className="post-container">
            <div className="post_div_view">
              <div className="post_gallery">
                <MediaViewer
                  product_filedata={product_filedata}
                  isLoading={isLoading}
                  logo_default={logo_default}
                />
              </div>
            </div>

            <div className="post_updates_view" >
              <div className="text-h1 fcap bold text-pre-25">{data?.title}</div>

              <div className="p-11 rounded m-top">
                <table>
                  <tr><td>
                    <div className="text-h1 fcap ">{data?.modelname}</div>
                  </td>
                    <td width={40}>
                      <div title="views" className="button-ui1"><CiRead className="icon" /> {data.views}</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Rating productId={data.uid} />
                    </td>
                   <td width={22}> 
                    <Saved product={data?.uid} /> 
                </td>
                  </tr>
                </table>
              </div>
              <div className="p-11 rounded m-top b-1">

                <table >
                  <tr>
                    <td>
                      {productsdata[0]?.child?.dealname != null && (
                        <tr><div className="button-ui red-back bold text-h3 ">{productsdata[0]?.child?.dealname}</div></tr>
                      )}
                    </td>
                    <td>
                      {productsdata[0]?.child?.benefit > 0 && productsdata[0]?.child?.benefit != null && (
                        <td width={150}><div className="m-top text-h3 sline text-off">Benefit: <a className="green bold green">₹ {productsdata[0]?.child?.benefit}/-</a></div></td>
                      )}
                    </td>
                  </tr>

                  <tr>

                    <td className="flex">
                      <div className="text-h1 red">-
                        {productsdata[0]?.child
                          ? `${Math.round(
                            ((productsdata[0]?.child?.mrp - productsdata[0]?.child?.price) /
                              productsdata[0]?.child?.mrp) *
                            100
                          )}%`
                          : ""}
                      </div>
                      &nbsp;&nbsp;
                      <div className="flex">  <span className="text-off text-h1">₹</span>
                        <div className="text-hero3 bold">{productsdata[0]?.child?.price || ""}</div>
                        <span className="text-off text-h1">.00</span></div>
                    </td>
                    <td width={100}>
                      {productsdata[0]?.child?.mrp > 0 && productsdata[0]?.child?.mrp != null && (
                        <div className=" text-h3 text-off">MRP: <span className="text-off ">₹</span><a className="th-line">{productsdata[0]?.child?.mrp}</a>/-</div>
                      )}
                    </td>
                  </tr>

                </table>
                <div className="text-h3 text-off ">Inclusive of all taxes</div>
              </div>

              <div className="p-11 rounded m-top">
                <table>
                  <tr>
                    <td>
                      {productsdata[0]?.child?.deliverycharges <= 0 &&
                        <table>
                          <tr>
                            <td width={90}>
                              <div className=" text-h2">Free Delivery</div>
                            </td>

                            <td>
                              <div className="text-h2 bold">
                                {" "}
                                {(() => {
                                  if (!productsdata[0]?.child?.deliverydays) return "N/A";

                                  const daysToAdd = parseInt(productsdata[0].child.deliverydays, 10);
                                  const deliveryDate = new Date();
                                  deliveryDate.setDate(deliveryDate.getDate() + daysToAdd);

                                  // Format like: Monday, Sep 30, 2025
                                  return deliveryDate.toLocaleDateString("en-US", {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  });
                                })()}
                              </div>
                            </td>
                          </tr>
                        </table>
                      }
                    </td>

                    <td>

                      {productsdata[0]?.child?.deliverycharges > 0 &&
                        productsdata[0]?.child?.deliverycharges != null &&
                        <div >
                          <div className="button-ui1 m-top p-0 text-h3">  Delivery Charges ₹ <b>{productsdata[0]?.child?.deliverycharges}</b>/- </div>

                          <div className="text-h2 bold">
                            Delivery {" "}
                            {(() => {
                              if (!productsdata[0]?.child?.deliverydays) return "N/A";

                              const daysToAdd = parseInt(productsdata[0].child.deliverydays, 10);
                              const deliveryDate = new Date();
                              deliveryDate.setDate(deliveryDate.getDate() + daysToAdd);

                              // Format like: Monday, Sep 30, 2025
                              return deliveryDate.toLocaleDateString("en-US", {
                                weekday: "long",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              });
                            })()}
                          </div>
                        </div>
                      }

                    </td>

                  </tr>
                </table>

              </div>
              <div className="p-11  rounded m-top ">
                {/* Sold by */}
                <div >

                  <div className="ui-grid-fill ">
                    {isLoading ? (
                      <Lodinging />
                    ) : companydata.length === 0 ? (
                      <div>No company found </div>
                    ) : (
                      companydata.map((row, index) => (
                        <div className="ui-items items-back p-0 " key={index}>
                          <table >
                            <tbody>
                              <tr>
                                <td>
                                  <div onClick={() => navigate("/" + row.slug)} className="text-h2 cursor hover-under">
                                    Visit the <b className="fcap bold ">{row.company}</b> Store
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="text-h3 text-off">Update:
                                    {row.date_time_update?.toDate
                                      ? row.date_time_update.toDate().toLocaleString("en-IN", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                      : "No data"}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                      ))
                    )}
                  </div>
                </div>
              </div>
              {/* buying */}

              <div className="p-11 rounded m-top">
                {isLoading3 ? (
                  <Lodinging />
                ) : salesdata.length === 0 ? (
                  <div>No sales found</div>
                ) : (
                  <table >

                    <tbody>
                      {salesdata.map((product, pIndex) =>
                        product.child && product.child.length > 0 ? (
                          product.child.map((field, fIndex) => (

                            <tr key={`${pIndex}-${fIndex}`}>
                              <td>
                                <div className="text-h2 fcap">{field.salesname}</div>
                              </td>
                              <td>
                                <div className="text-h2 fcap flex  "> <span className="text-off text-h2">₹</span><a className="text-h2 fcap bold">{field.saleprice}/-</a></div>
                              </td>
                              <td width={60} title={field.salesname}>
                                <a
                                  className="button-ui text-h2 sline cursor p-22"
                                  href={field.salesurl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Buy Now
                                </a>
                              </td>

                            </tr>
                          ))
                        ) : (
                          <tr key={`nochild-${pIndex}`}>
                            <td colSpan="4" className="text-center text-off">
                              No sales fields found for this product
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="m-top-5 ">
                <table className="table-fixed">
                  <tr>


                    <td  >
                      <div title="Compare" className="button-ui2 fill cursor p-2"
                        onClick={() => navigate("/compare/?slug=" + data.slug + "&uid=" + data.uid + "&cat=" + data.category + "&scat=" + data.subcategory)}
                      ><IoIosGitCompare className="icon" /> {data.compare} </div>
                    </td>

                    <td >

                      <Add_cart_buy product={data.uid} />

                    </td>
                  </tr>
                </table>
              </div>
              <div className="p-11 b-1 rounded m-top">
                <div className="ui-grid-services">
                  {productsdata[0]?.child?.deliverydays > 0 &&
                    productsdata[0]?.child?.deliverydays != null &&
                    <div className="ui-items ">
                      <table>
                        <tr>
                          <td className="center"><BsLightningCharge className='icon orange' /></td>
                        </tr>
                        <tr><td>
                          <div className="center text-h3 text-off sline fill">Delivery {productsdata[0]?.child?.deliverydays} Days</div>
                        </td></tr>
                      </table>
                    </div>
                  }
                  {
                    productsdata[0]?.child?.warranty != null && productsdata[0]?.child?.warrantystatus === true &&
                    <div className="ui-items ">
                      <table>
                        <tr>
                          <td className="center "><MdOutlineVerifiedUser className='icon orange' /></td>
                        </tr>
                        <tr><td>
                          <div className="center text-h3 text-off sline fill">{productsdata[0]?.child?.warranty}</div>
                        </td></tr>
                      </table>
                    </div>
                  }
                  {
                    productsdata[0]?.child?.warranty != null && productsdata[0]?.child?.warrantystatus === true &&
                    <div className="ui-items ">
                      <table>
                        <tr>
                          <td className="center"><TbTruckReturn className='icon orange' /></td>
                        </tr>
                        <tr><td>
                          <div className="center text-h3 text-off sline fill">
                            {productsdata[0]?.child?.notreturnablestatus === true ? "Yes" : "Not"} returnable
                          </div>
                        </td></tr>
                      </table>
                    </div>
                  }
                  {
                    productsdata[0]?.child?.cashpayon === true &&
                    <div className="ui-items">
                      <table>
                        <tr>
                          <td className="center "><GiCash className='icon orange' /></td>
                        </tr>
                        <tr><td>
                          <div className="center text-h3 text-off sline fill">Cash Pay</div>
                        </td></tr>
                      </table>
                    </div>
                  }
                  <div className="ui-items">
                    <table>
                      <tr>
                        <td className="center "><TbAward className='icon orange' /></td>
                      </tr>
                      <tr><td>
                        <div className="center text-h3 text-off fill">Brand</div>
                      </td></tr>
                    </table>
                  </div>
                  <div className="ui-items">
                    <table>
                      <tr>
                        <td className="center "><SiGnuprivacyguard className='icon orange' /></td>
                      </tr>
                      <tr><td>
                        <div className="center text-h3 text-off sline fill">Secure transaction</div>
                      </td></tr>
                    </table>
                  </div>
                </div>
              </div>
              <div className="m-top">
                <div className="center text-h2  sline">Colour: <b className="bold">{productsdata[0]?.child?.colorname || "Color Name"}</b></div>
                <div className="ui-grid-services" onClick={() => navigate("/" + productsdata[0]?.slug)}>
                  {productsdata[0]?.child?.color != null &&
                    productsdata[0]?.child?.colorname != null &&
                    <div className="ui-items rounded cursor"
                      style={{ border: `2px solid ${productsdata[0]?.child?.color || "#ccc"}` }}
                    >
                      <table >
                        <tr>
                          <td className="center"><img className="thumbnail_img" src={productsdata[0]?.thumbnail} /></td>
                        </tr>
                        <tr>
                          <td className="center">  <div className="text-h3 fcap bold">{data?.modelname}</div></td>
                        </tr>

                        <tr>
                          <td className="center">
                            <div className="text-h2 bold ">₹{productsdata[0]?.child?.price || ""}/-</div>
                          </td>
                        </tr>
                        <tr><td>
                          <div className="center text-h3 text-off bold" style={{ color: `${productsdata[0]?.child?.color || "#555"}` }}>{productsdata[0]?.child?.colorname || "Color Name"}</div>
                        </td></tr>
                      </table>
                    </div>
                  }
                </div>
              </div>

            </div>
          </div>

        </div>

        <br />
        <div className="container_size p-11">
          <div className="post-container">
            <div className="post_div" > <Comments productId={data.uid} />
              <div>
                <table>
                  <tr>
                    <td width={22}><TbMessageQuestion className="icon" /></td>
                    <td><div className="text-h3 blue hover-u cursor">Report an issue with this product</div></td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="post_div">
              <div className="text-h1 bold fcap p-1">About this item</div>
              <div
                className="text-pre"
                dangerouslySetInnerHTML={{
                  __html: data?.description?.replace(/\n/g, "<br>") || ""
                }}
              ></div>
            </div>
          </div>
        </div>
        {/* explanation_filedata */}
        {explanation_filedata && explanation_filedata.length > 0 && (
          <div className="container_size">
            <div className="text-hero3 bold m-b">Explanation</div>
            <VideoSlideshow
              vdeoslideshowf_file_filedata={explanation_filedata}
              banner_default="/default_banner.jpg"
            />
          </div>
        )}

        {manufacturer_filedata && manufacturer_filedata.length > 0 && (
          <div className="container_size">
            <br />
            <div className="text-hero3 bold m-b">From the manufacturer</div>
            {isLoading ? (
              <Loading_items />
            ) : manufacturer_filedata.length === 0 ? (
              <div></div>
            ) : (
              manufacturer_filedata.map((row, index) => (
                <img key={index} src={row.url || banner_default} className="banner_default" />
              ))
            )}
          </div>
        )}
        {/* review_slideshow_filedata */}
        {review_slideshow_filedata && review_slideshow_filedata.length > 0 && (

          <div className="container_size">

            <ReviewSlideshow
              review_slideshow_filedata={review_slideshow_filedata}
              banner_default={banner_default}
            />
          </div>
        )}
        {/* pptphotoshowf_file_filedata */}
        {pptphotoshowf_file_filedata && pptphotoshowf_file_filedata.length > 0 && (
          <div className="container_size">
            <br />
            <div className="text-hero3 bold m-b">PPT Show</div>
            <PPTSlideshow
              pptphotoshowf_file_filedata={pptphotoshowf_file_filedata}
              banner_default="/default_banner.jpg"
            /> </div>
        )}
        <br />
        <div className="container_size p-11">
          <div className="post-container">
            <div className="post_div" >
              <div >
                <div className="text-h1 bold fcap p-2 items-back-fill">Technical Details</div>
                <TechnicalDetails isLoading3={isLoading3} technicaldata={technicaldata} />
              </div>
              <br />
            </div>
            <div className="post_div">
              <div className="text-h1 bold fcap p-2 items-back-fill">Additional Information</div>
              <AdditionalInformation isLoading3={isLoading3} additionaldata={additionaldata} />
            </div>

          </div>
        </div>

        <div className="container_size p-11 m-top">
          <div className="text-h1 bold m-b b-1 p-22">Explore top deals in related categories items <a className="button-ui2 bold text-h1">{compareData.length}</a></div>
          <div className="ui-grid-mobile-1item m-top">
            {isLoading ? (
              <Loadingimg />
            ) : compareData.length === 0 ? (
              <div></div>
            ) : (
              compareData.map((row, index) => (
                <div className="ui-items items-back shadow  rounded" key={index}>
                  <div
                    className="w-back-30"
                    style={{
                      zIndex: "2",
                      position: "absolute",
                      left: "0px",
                      right: "0px",
                      top: "0px",
                    }}
                  >

                  </div>
                  <div style={{ position: "relative" }}>
                    <div className="w-back-30" style={{ position: "absolute", top: 0, left: 0, right: 0, zIndex: 2 }}>
                      <table>
                        <tr>
                          <td>
                            <div className="text-shadow-w text-h2 p-11 fcap bold">{row.brandname}</div>
                          </td>
                          <td width={30}>

                            {row.child?.dealname != null && (
                              <div className="text-h5 red-back white p-1 rounded">-
                                {row.child
                                  ? `${Math.round(
                                    ((row.child?.mrp - row.child?.price) /
                                      row.child?.mrp) *
                                    100
                                  )}%`
                                  : ""}
                              </div>
                            )}

                          </td>
                        </tr>
                      </table>


                    </div>
                    <div className="w-back-30" style={{ zIndex: "2", position: "absolute", left: "0px", right: "0px", bottom: "0px" }}>
                      <table>
                        <tr>
                          <td><div className="text-shadow-w text-h2 fcap bold"><Saved product={row.uid} /></div></td>
                          <td width={90} > <Rating productId={row.uid} /></td>
                        </tr>
                      </table>
                    </div>
                    <img src={row.thumbnail} onClick={() => navigate("/" + row.slug)} className="ads-items-default" />
                  </div>
                  <div className="p-1"  >
                    <div className="text-h2 fcap m-b">{row.title.substring(0, 45)} ...</div>

                    {row.child?.dealname != null && (
                      <div>
                        <a className="red text-h3 bold items-back   rounded-sm">{row.child?.dealname}</a>
                      </div>
                    )}
                    <table className="table-fixed">
                      <tr>
                        <td >

                          <div className="flex">
                            <span className="text-off text-h1">₹</span>
                            <div className="text-h1 bold">{row.child?.price || ""}</div>
                            <span className="text-off text-h2">.00</span>
                          </div>
                        </td>
                        <td  >

                        </td>


                        <td  >
                          {row.child?.mrp > 0 && row.child?.mrp != null && (
                            <div className=" text-h2 text-off"><span className="text-off ">₹</span><a className="th-line">{row.child?.mrp}</a>.00</div>
                          )}
                        </td>
                      </tr>

                    </table>

                    <div className="m-top-5 ">
                      <table className="table-fixed">
                        <tr>


                          <td  >
                            <div title="Compare" className="button-ui2 fill cursor "
                              onClick={() => navigate("/compare/?slug=" + row.slug + "&uid=" + row.uid + "&cat=" + row.category + "&scat=" + row.subcategory)}
                            ><IoIosGitCompare className="icon" /> {row.compare} </div>
                          </td>

                          <td >

                            <Add_cart product={row.uid} />

                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      <br />


    </div>
  );
}
